import { render, staticRenderFns } from "./firmasil.vue?vue&type=template&id=a00e22aa"
import script from "./firmasil.vue?vue&type=script&lang=js"
export * from "./firmasil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports